import { authHref } from '@/shared/lib/auth-return';
import Link from 'next/link';

export function GoToRestoreLink({
	redirectPath,
}: { redirectPath?: string } = {}) {
	return (
		<Link
			href={authHref('/login/restore', redirectPath)}
			className="text-accent hover:text-accent-hover"
		>
			Забыли пароль?
		</Link>
	);
}
